import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import * as Sentry from '@sentry/capacitor';
import { Subject, takeUntil } from 'rxjs';
import { Logger } from '@app/utils/logger';
import { EventService } from '@providers/event/event.service';
import { Session } from '@providers/session/session.service';

/**
 * Sentry Component.
 */
@Component({
  selector: 'app-sentry',
  template: ``,
  standalone: true
})
export class SentryComponent implements OnInit, OnDestroy {
  private readonly event = inject(EventService);
  private readonly session = inject(Session);

  logger = Logger.getInstance('SentryComponent');
  destroyed = new Subject<boolean>();

  /**
   * On Init.
   *
   * @returns {void}
   */
  ngOnInit(): void {
    this.setUser();
    this.subscribe();
  }

  /**
   * On Destroy.
   *
   * @returns {void}
   */
  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  /**
   * Subscribe to events.
   *
   * @returns {void}
   */
  subscribe(): void {
    this.event
      .listen(this.event.keys.LOGIN)
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => {
        setTimeout(() => {
          this.setUser();
        }, 200);
      });
    this.event
      .listen(this.event.keys.LOGOUT)
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => {
        setTimeout(() => {
          this.setUser();
        }, 200);
      });
  }

  /**
   * Set User.
   *
   * @returns {void}
   */
  setUser(): void {
    const user = this.session.get();
    if (user) {
      Sentry.setUser({
        username: user.username,
        id: user.username,
        ip_address: '{{auto}}'
      });
    } else {
      Sentry.setUser(null);
    }
  }
}
